<template>
    <div class="main-content">
        <!-- BradCrumb header Start-->
        <section class="inner-header-bg">
            <div class="container">
                <!-- Breadcrumb Start-->
                <div class="section-breadcrumb portfolio-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 justify-content-center align-self-center pb-2">
                                <div class="breadcrumb-content">
                                    <div class="title-section">
                                        <h1 class="title text-center text-white">Membership Advantages</h1>
                                    </div>
                                    <div class="breadcrumb-nav">
                                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                                            <li class="text-white">
                                                <i class="mdi mdi-home theme-light-color pr-2"></i>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li class="theme-light-color active">Portfolio</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Breadcrumb End -->
            </div>
        </section>
        <!-- BradCrumb header End -->
        <!-- Start Portfolio Area -->
        <section class="section portfolio-section" id="portfolio">
            <div class="container">
                <div class="section-title text-center z-index9">
                    <span>MEMBERSHIP</span>
                    <h2>Member Benefits</h2>
                </div>
                <div class="portfolio-items row no-gutters mt-4  wow fadeIn" data-wow-duration="1s">
                    <!-- Item 01 -->
                    <div class="col-sm-6 portfolio-item seo">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/project_participation.jpg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Project Participation</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 02 -->
                    <div class="col-sm-6 portfolio-item graphic webdesign">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/intellectual_property.jpg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Intellectual Property</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 03 -->
                    <div class="col-sm-6 portfolio-item webdesign graphic">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/educational_curriculum.jpg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Educational Curriculum</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 04 -->
                    <div class="col-sm-6 portfolio-item mobiledesign webdesign">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/workshops.jpg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Briefing and Workshops</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Item 05 -->
                    <div class="col-sm-6 portfolio-item mobiledesign seo">
                        <div class="image-border">
                            <div class="portfolio-box scale-image">
                                <img src="../assets/images/images/defense_community.jpg" class="img-fluid" alt="">
                                <div class="img-overlay text-white text-center">
                                    <h5 class="mb-0">Defense Community Access</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Portfolio Area -->
		 <section class="section">
            <div class="container">
                <div class="row">
					<div class="col-12">
                        <div class="mt-4 text-lg-left text-center">
                            <h2>An Institute for Nascent Innovation</h2>
                            <p>
								I4NI represents a revolutionary opportunity for the Department of Defense and other Federal Government Agencies to harvest innovation devised and matured in academia, industry, national laboratories and a host of nontraditional domestic sources such as small and medium-sized businesses, inventors, and entrepreneur.
							</p>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div>
                            <img src="../assets/images/images/process.jpg" alt="" class="img-fluid w-100">
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="services-info-box">
                            <div class="section-title">
                                <h2 class="title position-relative pb-2 mb-3">Process</h2>
                            </div>
                            <ul class="list-unstyled mb-0">
                                <li>
                                    <a href="#" class="text-dark">
                                        Maintain Technology Awareness
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="text-dark">
                                        Identify, recruit, and retain key entities 
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="text-dark">
                                        Accelerate and demonstrate delivery of innovation
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    //ISOTOP JS
    import '../assets/js/jquery.isotope.min.js';
    import * as ScrollMagic from "scrollmagic";
    import { TweenMax, TimelineMax } from "gsap"; 
    //MAGNIFIC POPUP JS
    import 'magnific-popup/dist/jquery.magnific-popup.min.js';
    import 'magnific-popup/dist/magnific-popup.css';
    export default {
        name: 'portfolio2',
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.initIsotop();
                this.initMagnificPopup();
                this.initScaleImage();
                this.initFooterHeight();
            },
             initFooterHeight() {
                var footerHeight = $("footer").outerHeight();
                $('.main-content').css('margin-bottom', footerHeight);
            },
            /*----ISOTOP JS-----*/
            initIsotop() {
                var $container = $('.portfolio-items');
                $container.imagesLoaded(function () {
                    $container.isotope({
                        filter: '*',
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });
                });

                $('.portfolio-filter a').click(function () {
                    $('.portfolio-filter .current').removeClass('current');
                    $(this).addClass('current');
                    var selector = $(this).attr('data-filter');
                    $container.isotope({
                        filter: selector,
                        animationOptions: {
                            duration: 750,
                            easing: 'linear',
                            queue: false
                        }
                    });
                    return false;
                });
            },
            /*----MAGNIFIC POPUP JS-----*/
            initMagnificPopup() {
                if (('.portfolio-items').length > 0) {
                    $('.portfolio-items').each(function () {
                        $(this).magnificPopup({
                            delegate: '.js-zoom-gallery',
                            type: 'image',
                            gallery: {
                                enabled: true
                            }
                        });
                    });
                }
            },
            initScaleImage() {
                var controller = new ScrollMagic.Controller();
                var slides = $('.scale-image');
                for (var i = 0; i < slides.length; i++) {
                    var image = $('img', slides[i]);
                    var tween = TweenMax.to(image, 1, { scale: 1.2 });
                    var scene = new ScrollMagic
                        .Scene({
                            triggerElement: slides[i],
                            duration: "200%",
                            triggerHook: 'onEnter'
                        })
                        .setTween(tween)
                        .addTo(controller);
                }
            }
        }
    }
</script>